<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="기본 정보">
            <div class="columns is-multiline">
              <div class="column is-half">
                <admin-form-item label="아이디*">
                  <input class="input"
                         :value="basicInfo.username"
                         @input="inputUserName"
                         placeholder="launchpack"
                         type="text" :disabled="inputDisabled" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="이름">
                  <input class="input"
                         :value="basicInfo.name"
                         @input="e => basicInfo.name = e.target.value"
                         placeholder="홍길동"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호*">
                  <input class="input"
                         :value="basicInfo.password"
                         @input="e => basicInfo.password = e.target.value"
                         placeholder="비밀번호를 입력하세요."
                         type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호 확인*">
                  <input class="input"
                         :value="basicInfo.passwordCheck"
                         @input="e => basicInfo.passwordCheck = e.target.value"
                         placeholder="비밀번호를 확인하는 곳 입니다."
                         type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="휴대전화번호">
                  <input class="input"
                         :value="basicInfo.phone"
                         @input="e => basicInfo.phone = e.target.value"
                         type="text" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <button class="button" @click="$modal.show('changePasswordModal')" v-if="supervisor_id">비밀번호 변경</button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <div class="box" v-if="supervisor_id">
      <admin-box-item title="소속 파트너 설정">
        <div class="flex-align" style="margin:12px 0">
          <button class="button is-primary"
                  style="margin-right:12px"
                  @click="$modal.show('partnerListModal')">파트너 추가
          </button>
          <button class="button is-primary" @click="openDeletePartnerModal">선택 삭제</button>
        </div>

        <admin-table :field_list="tableData"
                     :items="tableItems"
                     :filtered="filtered"
                     :allCount="allCount"
                     :filteredCount="filteredCount"
                     :table_width="600"
                     @check="clickCheckBox"
                     @getData="getDataFromServer"
                     @ordering="ordering"
                     @selPageLength="selPageLength">
          <div slot="checkspot" slot-scope="props">
            <lp-check-bool
              v-if="showcaseCheckArr[props.idx]!==undefined"
              :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
          </div>
        </admin-table>
      </admin-box-item>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <modal name="partnerListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <partner-list page="partner_supervisor" @tableItems="selectPartner"
                    :selectedItems="partner_id_list"></partner-list>
      <!--<group-list @groupItems="groupItems" page="superpartner" :selectedItems="id_list" style="zoom: 0.85"></group-list>-->
    </modal>

    <modal name="deletePartnerModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="삭제" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 파트너를 삭제하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deletePartnerModal')">취소</button>
            <button class="button is-primary" @click="deletePartner">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <modal name="changePasswordModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="비밀번호 변경" :useTabl="false">
          <div class="column is-half">
            <admin-form-item label="비밀번호*">
              <input class="input"
                     :value="origin_password"
                     @input="e => origin_password = e.target.value"
                     placeholder="비밀번호를 입력하세요."
                     type="password" maxlength="15">
            </admin-form-item>
          </div>
          <div class="column is-half"></div>
          <div class="column is-half">
            <admin-form-item label="새비밀번호*">
              <input class="input"
                     :value="new_password"
                     @input="e => new_password = e.target.value"
                     placeholder="비밀번호를 입력하세요."
                     type="password" maxlength="15">
            </admin-form-item>
          </div>
          <div class="column is-half">
            <admin-form-item label="새비밀번호 확인*">
              <input class="input"
                     :value="new_password_re"
                     @input="e => new_password_re = e.target.value"
                     placeholder="비밀번호를 확인하는 곳 입니다."
                     type="password" maxlength="15">
            </admin-form-item>
          </div>
        </admin-box-item>
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="changePassword">변경하기</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import moment from 'moment';
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import InputImg from '../../module/common/InputImg'
  import LpAddress from '../../module/common/LpAddress'
  import LpAdmDropInput from '../../module/common/LpAdmDropInput'
  import LpDateDropInput from "../../module/common/LpDateDropInput";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import InputParam from "../../module/custom/InputParam";
  import CreateMixin from "@/mixins/CreateMixin"
  import PartnerList from "../partner/PartnerList";
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";


  export default {
    name: 'SuperVisorCreate',
    layout: 'Main',
    components: {
      LpCheckBool,
      PartnerList,

      InputParam,
      LpSortDropDown,
      LpDateDropInput,
      LpInputText,
      LpRadio, InputImg, LpAddress,
      LpAdmDropInput
    },
    mixins: [
      CreateMixin,
      ListMixin
    ],
    data() {
      return {
        // 기본 정보
        basicInfo: {
          username: '',
          // id: '',
          password: '',
          passwordCheck: '',
          email: '',
          address: {
            full: '',
            sido: '',
            sigungu: '',
            dong: '',
            zipcode: '',
            detail: ''
          },
          name: '',
          partners: []
        },
        emailValid: false,
        partner_id_list: [],
        supervisor_id: 0,
        origin_password: '',
        new_password: '',
        new_password_re: ''
      }
    },
    computed: {
      inputDisabled() {
        if (this.supervisor_id) {
          return true;
        } else return false;
      }
    },
    created() {
      if (this.$store.getters.mode === 'supervisor') {
        this.supervisor_id = this.$store.getters.supervisor.id;
      } else {
        this.supervisor_id = this.$route.query.id;
      }
      if (this.$route.query.id || this.$store.getters.mode === 'supervisor') {
        this.init();
        this.getSuperVisorDetail();
        this.getPartnerIdList();
      }
    },
    methods: {
      init() {
        let path = `supervisor/${this.supervisor_id}/partner?supervisor_id=${this.supervisor_id}`;
        this.initializing('supervisors_partner', path);
      },
      getDataFromServer() {
        this.getData();
      },
      getPartnerIdList() {
        let url = `supervisor/${this.supervisor_id}/partner/simple`
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            let partner_ids = [];
            res.data.forEach(item => {
              partner_ids.push(item.value);

            })
            this.partner_id_list = partner_ids;
          }
        })
      },
      // 파트너 선택
      selectPartner(res) {
        // let url = `supervisor/${this.supervisor_id}/partner`;
        let selected_ids = res.id_list;
        // 강남 0 , 관악 1
        this.tableItems = this.tableItems.concat(res.tableItems.filter(i =>
          this.tableItems.map(t => t.id).indexOf(i.id) === -1));

        // id번호 배열 구성후 변수에 저장
        let tableList = [];
        for (let i = 0; i < this.tableItems.length; i++) {
          tableList.push({id: this.tableItems[i].id, value: false, isNew: true});
          this.tableItems[i]['index'] = i+1;
        }

        this.tableItems = this.tableItems.sort(function (a, b) {
          return b.index - a.index;
        })

        this.showcaseCheckArr = tableList;

        let partner_ids = this.cloneItem(this.partner_id_list);
        selected_ids.forEach(id => {
          if (this.partner_id_list.indexOf(id) === -1) {
            partner_ids.push(id)
          }
        })
        /*this.$axios.post(this.getUrl(url), {
          partners: partner_ids
        }).then(res => {
          if (res.status === 200) {
            this.toast('파트너가 추가되었습니다.');
            this.getData();
          }
        })*/
        this.basicInfo.partners = partner_ids;
        this.$modal.hide('partnerListModal');
      },
      inputUserName(e) {
        this.basicInfo.username = e.target.value;
        this.basicInfo.email = e.target.value;
      },
      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      getSuperVisorDetail() {
        // 유저 정보가 있는 경우 가져오기
        this.$axios.get(this.getUrl('supervisor/' + this.supervisor_id))
          .then(res => {
            if (res.status === 200) {
              this.basicInfo = res.data;
            }
          });
      },
      async saveData() {
        let errMsg = '';
        if (!this.basicInfo.username) errMsg = '아이디를 입력하세요.';

        if (!this.basicInfo.password) errMsg = '비밀번호를 입력하세요.';
        else if (!this.basicInfo.passwordCheck) errMsg = '비밀번호 확인을 입력하세요.';
        else if (this.basicInfo.password !== this.basicInfo.passwordCheck) errMsg = '새 비밀번호를 다시 확인해주세요.';

        if (errMsg) {
          this.toast(errMsg);
          return;
        }
        if (this.basicInfo.password !== this.basicInfo.passwordCheck) {
          this.toast('비밀번호를 확인해주세요.');
          return;
        }

        this.$store.commit('setLoading', true);
        // 수정
        if (this.supervisor_id) {
          try {
            let l_result = await this.login();
          } catch (error) {
            this.$store.commit('setLoading', false);
            this.toast('비밀번호가 일치하지 않습니다.')
            return;
          }
          // user_param 추가
          await this.$axios.patch(this.getUrl('supervisor/' + this.supervisor_id), this.basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.getData();
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          });
        //  등록
        } else {
          await this.$axios.post(this.getUrl('supervisor'), this.basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              if(this.$store.getters.mode==='admin') {
                this.$router.replace(this.getPath('supervisor'));
              }
              else {
                this.getData();
              }
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          })
        }
      },
      // 체크박스 선택 관련 - 일괄 선택시 선택한 id list를 조합함
      getIdList() {
        let id_list = [];
        for (let i = 0; i < this.showcaseCheckArr.length; i++) {
          for (let j = 0; j < this.tableItems.length; j++) {
            if (this.showcaseCheckArr[i].value && this.showcaseCheckArr[i].id === this.tableItems[j].id) {
              id_list.push(this.tableItems[j].id);
            }
          }
        }
        return id_list;
      },
      openDeletePartnerModal() {
        let id_list = this.getIdList();
        if (id_list.length === 0) {
          this.toast('삭제할 파트너를 선택해주세요.');
          return;
        }
        this.$modal.show('deletePartnerModal')
      },
      deletePartner() {
        let id_list = this.getIdList();
        let url = `supervisor/${this.supervisor_id}/partner/delete/multiple`;
        this.$axios.delete(this.getUrl(url), {
          data: {
            partners: id_list
          }
        }).then(res => {
          if (res.status === 200) {
            this.toast('선택한 파트너가 삭제되었습니다.');
            this.$modal.hide('deletePartnerModal');
            this.getData();
            this.getSuperVisorDetail();
          }
        })
      },
      async login () {
        let params = {
          username: this.basicInfo.username,
          password: this.basicInfo.password
        }
        return await this.$axios.post('auth/supervisor/login', params)
      },
      async changePassword() {
        let errMsg = '';
        if (!this.new_password) errMsg = '비밀번호를 입력하세요';
        else if (!this.new_password_re) errMsg = '비밀번호 확인을 입력하세요';
        else if (this.new_password !== this.new_password_re) errMsg = '새 비밀번호를 다시 확인해주세요.';
        if (errMsg) {
          this.toast(errMsg);
          return
        }

        try {
          let l_result = await this.login();
        } catch (error) {
          this.toast('비밀번호가 일치하지 않습니다.')
          return;
        }
        let url = `supervisor/${this.supervisor_id}/password`;
        await this.$axios.post(this.getUrl(url), {
          password: this.new_password
        }).then(res => {
          if (res.status === 200) {
            this.toast('비밀번호가 변경되었습니다.');
            this.$modal.hide('changePasswordModal');
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .service-usage-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-usage-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .user-reg-history-memo
    width 100%
    height 196px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto

  .history-memo-item
    width 100%
    margin-bottom 12px

  .user-reg-history-btn
    background-color $primary
    color #fff
    display inline-block
    padding 8px 12px
    margin-left 8px
    border-radius 3px
    cursor pointer


</style>
